import { Component } from "react";
import { Link } from "react-router-dom";
import "./NavbarStyles.css";
import { MenuItems } from "./MenuItems";

export default class Navbar extends Component {
  state = {clicked : false};
  handleClick  = ()=>{
    this.setState({clicked : !this.state.clicked});
  }
  render() {
    return (
      <nav className="NavbarItems">
        <h1 className="navbar-logo">Trippy</h1>
        <div className="menu-icons">
          <i onClick= {this.handleClick}  className= {this.state.clicked ? "fas fa-times" : "fas fa-bars"}></i>
          {/* <i className= "fas fa-times"></i> */}
        </div>

        <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
          {MenuItems.map((item, index) => {
            return (
              <li key= {index}>
                <Link className = {item.cName} to={item.url}>
                  <i class={item.icon}></i>{item.title}
                </Link>
                
              </li>
            );
          })}
          <button>Signup</button>
        </ul>
      </nav>
    );
  }
}
